import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSatna = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={21} height={20} fill='none' {...props}>
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      d='M13.367 1.667h-5.4c-3.134 0-3.375 2.816-1.684 4.35l8.767 7.966c1.692 1.534 1.45 4.35-1.683 4.35h-5.4c-3.134 0-3.375-2.816-1.684-4.35l8.767-7.966c1.692-1.534 1.45-4.35-1.683-4.35'
    />
  </svg>
);
export default SvgSatna;
